import { extractTextFromPDF } from './fileProcessing/pdfExtractor';
import { extractTextFromDOCX } from './fileProcessing/docxExtractor';
import { extractTextFromTXT } from './fileProcessing/txtExtractor';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export async function extractTextFromFile(file: File): Promise<string> {
  try {
    if (file.size > MAX_FILE_SIZE) {
      throw new Error('File is too large. Maximum size is 10MB.');
    }

    let text = '';
    const fileType = file.type.toLowerCase();
    
    if (fileType.includes('pdf')) {
      text = await extractTextFromPDF(file);
    } else if (fileType.includes('wordprocessingml.document') || fileType.includes('msword')) {
      text = await extractTextFromDOCX(file);
    } else if (fileType.includes('text/plain') || file.name.endsWith('.txt')) {
      text = await extractTextFromTXT(file);
    } else {
      return 'Error: Unsupported file type. Please upload a PDF, DOCX, or TXT file.';
    }
    
    if (!text || text.length < 10) {
      return 'Error: The file appears to be empty or could not be processed. Please try a different file.';
    }
    
    return text;
  } catch (error) {
    console.error('File processing error:', error);
    return 'Error: Could not process the file. Please try uploading a different file.';
  }
}